import { Tooltip } from '@mui/material';
import { Button } from '@/shared/ui';
import { useNavigationVersion } from '../../model/useNavigationVersion';

export function OldVersionSwitcher() {
  const { switchToV1 } = useNavigationVersion();

  return (
    <Tooltip arrow placement="right" title="Click to switch to old version">
      <Button
        component="span"
        variant="outlined"
        sx={{
          cursor: 'pointer',
          minWidth: 0,
          border: (theme) => `1px solid ${theme.palette.primary.main}`,
          color: 'primary.main',
          fontSize: 9,
          fontWeight: 500,
          textTransform: 'uppercase',
          letterSpacing: '0.4px',
          padding: '1px 5px',
          borderRadius: 1,
          lineHeight: '14px',
          flexShrink: 0,
        }}
        onClick={switchToV1}
      >
        v2
      </Button>
    </Tooltip>
  );
}
